// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see GlobalConfigurationCheckIntegrityEvent
 */
export var GlobalConfigurationCheckIntegrity = function (_a) {
    var trigger = _a.trigger, result = _a.result;
    return ({
        name: "GlobalConfiguration Check Integrity",
        parameters: {
            cdf_entity: "GlobalConfiguration",
            cdf_action: "Check",
            trigger: trigger.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH),
            result: result.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH)
        }
    });
};
